/**
 * 요청 취소(abort) 판별.
 *
 * 사용자가 화면을 떠나거나 같은 작업을 다시 제출하면 진행 중이던 요청을 AbortController 로
 * 끊는다. 실패가 아니라 의도된 취소이므로 전역 에러 토스트나 실패 telemetry 를 내면 안 된다.
 *
 * 던져지는 에러 형태가 두 가지다 — axios 는 CanceledError(name 'CanceledError',
 * code 'ERR_CANCELED', message 'canceled'), fetch 는 DOMException('AbortError').
 * 둘 다 message 가 영문 원문이라 전역 토스트에 그대로 실리면 사용자에게 영어가 노출된다.
 * axios.isCancel 은 DOMException 을 잡지 못하고, name 검사는 반대로 axios 쪽을 놓치므로
 * 세 갈래를 함께 본다. code 갈래는 __CANCEL__ 마커가 유실된 채 전파된 axios 에러까지 덮는다.
 */

import axios from 'axios';

export function isRequestCanceledError(error: unknown): boolean {
  if (axios.isCancel(error)) return true;
  if (typeof error !== 'object' || error === null) return false;
  // instanceof Error 로 좁히면 안 된다 — jsdom 의 DOMException 은 Error 를 상속하지 않아
  // fetch abort 를 통째로 놓친다(브라우저에서는 상속한다). name 만 본다.
  if ((error as { name?: unknown }).name === 'AbortError') return true;
  return (error as { code?: unknown }).code === 'ERR_CANCELED';
}
